<form [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="modal-header">
    <h2 class="modal-title" id="ks-prefill-value-modal-title">{{ title() }}</h2>

    <button type="button" class="ks-modal-close" aria-label="Cerrar" (click)="cancel()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="ks-form-group">
      <label class="ks-label" for="ks-prefill-value-field">Campo de la plantilla</label>

      <!--
        ng-select, no <select>: todos los desplegables de la consola deben
        permitir BUSCAR. El id del input interno lo pone `labelForId`, asi que
        el `<label for>` de arriba sigue apuntando al elemento que recibe el
        foco. `aria-describedby` senala SIEMPRE al mismo id: la pista y el
        error son excluyentes en la plantilla, asi que solo uno existe a la
        vez.
      -->
      <ng-select
        labelForId="ks-prefill-value-field"
        formControlName="templateFieldId"
        [items]="fieldOptions()"
        bindLabel="label"
        bindValue="templateFieldId"
        placeholder="Selecciona un campo"
        notFoundText="Sin resultados"
        clearAllText="Quitar selección"
        loadingText="Cargando…"
        typeToSearchText="Escribe para buscar"
        [searchable]="true"
        [inputAttrs]="fieldInputAttrs()"
        [class.is-invalid]="invalid('templateFieldId')" />

      @if (invalid('templateFieldId')) {
        <p class="ks-field-error" id="ks-prefill-value-field-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Elige el campo al que pertenece el valor.
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-prefill-value-field-hint">
          @if (isEdit()) {
            El campo no se puede cambiar. Elimina el valor y créalo de nuevo si te equivocaste.
          } @else {
            Solo se listan los campos de la plantilla que aún no tienen valor.
          }
        </p>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-prefill-value-value">Valor</label>

      @if (isMultiline()) {
        <textarea
          id="ks-prefill-value-value"
          class="ks-field"
          formControlName="value"
          rows="4"
          [attr.aria-invalid]="invalid('value') ? 'true' : null"
          [attr.aria-describedby]="invalid('value') ? 'ks-prefill-value-value-error' : 'ks-prefill-value-value-hint'"></textarea>
      } @else {
        <div class="ks-secret">
          <input
            id="ks-prefill-value-value"
            class="ks-field"
            [type]="inputType()"
            formControlName="value"
            autocomplete="off"
            spellcheck="false"
            [attr.aria-invalid]="invalid('value') ? 'true' : null"
            [attr.aria-describedby]="invalid('value') ? 'ks-prefill-value-value-error' : 'ks-prefill-value-value-hint'" />

          @if (isProtected()) {
            <button
              type="button"
              class="ks-icon-btn ks-secret__toggle"
              [attr.aria-label]="revealed() ? 'Ocultar el valor' : 'Mostrar el valor'"
              [attr.aria-pressed]="revealed()"
              (click)="toggleReveal()">
              <i class="bi" [class.bi-eye]="!revealed()" [class.bi-eye-slash]="revealed()" aria-hidden="true"></i>
            </button>
          }
        </div>
      }

      @if (invalid('value')) {
        <p class="ks-field-error" id="ks-prefill-value-value-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Escribe el valor (máximo 2000 caracteres).
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-prefill-value-value-hint">
          @if (isProtected()) {
            Este campo es protegido: la app cifra el valor y lo muestra oculto.
          } @else {
            Es el texto que la app propondrá al crear una credencial con esta plantilla.
          }
        </p>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>
    <button type="submit" class="ks-btn ks-btn--primary">
      <i class="bi bi-check-lg" aria-hidden="true"></i>
      Guardar
    </button>
  </div>
</form>
